import React from "react";
import "./policies.css";

export default function Policies() {
    return (
        <>
            <div className="Policy-container">
                <span className="pol-content">
                    At Born2Scale, we value your privacy and are committed to protecting the personal information you provide to us through Facebook Instant Forms.
                    This Privacy Policy outlines how we collect, use, and safeguard your personal information.</span>
                <ol className="ordered-list">
                    <li className="list">
                        Information We Collect When you submit your details via our Facebook Instant Forms,
                        we may collect the following personal information:
                        <ul className="unordered-list">
                            <li>Full Name</li>
                            <li>Email Address</li>
                            <li>Phone Number</li>
                            <li>Business Name</li>
                            <li>Marketing Budget</li>
                            <li>Other details you voluntarily provide through the form</li>
                        </ul>
                    </li>
                    <li className="list">
                        How We Use Your Information The information collected is used for the following purposes
                        <ul className="unordered-list">
                            <li>To contact you regarding our social media marketing services</li>
                            <li>To provide you with a customized strategy to improve your return on investment (ROI)</li>
                            <li>To follow up on your inquiry and answer any questions</li>
                            <li>To send marketing or promotional communications (if you've opted in)</li>
                        </ul>
                    </li>
                    <li className="list">
                        Information Sharing We do not sell, trade, or otherwise transfer your personal information to outside parties. Your data will
                        only be shared with our internal team or service providers directly involved in fulfilling your inquiry.
                    </li>
                    <li className="list">
                        Data Security We take appropriate measures to ensure the security
                        of your personal information and protect it from unauthorized access, alteration, or disclosure.
                    </li>
                    <li className="list">
                        Your Consent By submitting your information through our Facebook
                        Instant Form, you consent to the collection and use of your personal information as outlined in this Privacy Policy.
                    </li>
                    <li className="list">
                        Your Rights You have the right to request access to the information we hold about you, correct any inaccuracies,
                        or request the deletion of your data. To exercise any of these rights, please contact us at born2scale@gmail.com.
                    </li>
                    <li className="list">
                        Changes to Our Privacy Policy We reserve the right to update or modify this Privacy
                        Policy at any time. Any changes will be posted on this page, and we encourage you to review it periodically.
                    </li>
                </ol>
            </div>
        </>
    )
}